const React = require('react');

class SetClientProps extends React.Component {
  render() {
    const { component: { constructor: { name }, props } } = this.props;

    return typeof window === 'undefined'
      ? (
        <script dangerouslySetInnerHTML={{
          __html: `window.__PROPS__.${name} = ${JSON.stringify(props)}`
        }} />
      )
      : null;
  }
}

module.exports = SetClientProps;
